import React from 'react';
import { X, Eye } from 'lucide-react';

const ColumnVisibilityModal = ({ isOpen, onClose, columns, visibleColumns, onToggleColumn, onSelectAll, onDeselectAll }) => {
  if (!isOpen) return null;

  const allVisible = columns.every(col => visibleColumns[col.key]);
  const noneVisible = columns.every(col => !visibleColumns[col.key]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <div className="flex items-center">
            <Eye size={20} className="mr-2 text-gray-600" />
            <h3 className="text-lg font-semibold">Column Visibility</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </button>
        </div>

        {/* Quick Actions */}
        <div className="p-4 bg-gray-50 border-b flex gap-2">
          <button
            onClick={onSelectAll}
            disabled={allVisible}
            className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Select All
          </button>
          <button
            onClick={onDeselectAll}
            disabled={noneVisible}
            className="px-3 py-1 text-sm bg-gray-600 text-white rounded hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Deselect All
          </button>
        </div>

        {/* Column List */}
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <div className="space-y-2">
            {columns.map((column) => (
              <label
                key={column.key}
                className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={visibleColumns[column.key] !== false}
                  onChange={() => onToggleColumn(column.key)}
                  className="mr-3 h-4 w-4 text-blue-600 rounded"
                />
                <span className="text-sm font-medium">{column.label}</span>
                {column.required && (
                  <span className="ml-2 text-xs text-red-600">*</span>
                )}
              </label>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnVisibilityModal;
